import { render, staticRenderFns } from "./BlacklistItem.vue?vue&type=template&id=2f39daaf&scoped=true"
import script from "./BlacklistItem.vue?vue&type=script&lang=js"
export * from "./BlacklistItem.vue?vue&type=script&lang=js"
import style0 from "./BlacklistItem.vue?vue&type=style&index=0&id=2f39daaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f39daaf",
  null
  
)

export default component.exports